import React from 'react';
import './Input.css';

const Input = ({
  id,
  name,
  type = 'text',
  label,
  value,
  onChange,
  placeholder = '',
  disabled = false,
  error = '',
  required = false,
  autoComplete = 'off',
  iconLeft = null,
  iconRight = null,
  ...props
}) => {
  const inputClasses = `
    input-field
    ${error ? 'input-error' : ''}
    ${iconLeft ? 'input-with-icon-left' : ''}
    ${iconRight ? 'input-with-icon-right' : ''}
  `.trim();

  return (
    <div className="input-container">
      {label && (
        <label className="input-label" htmlFor={id || name}>
          {label} {required && <span className="required">*</span>}
        </label>
      )}
      <div className="input-wrapper">
        {iconLeft && <span className="input-icon input-icon-left">{iconLeft}</span>}
        <input
          id={id || name}
          name={name}
          type={type}
          className={inputClasses}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          disabled={disabled}
          required={required}
          autoComplete={autoComplete}
          {...props}
        />
        {iconRight && <span className="input-icon input-icon-right">{iconRight}</span>}
      </div>
      {error && <p className="error-message">{error}</p>}
    </div>
  );
};

export default Input; 